import { apiAuthClient } from 'api/helpers';

import { safeJsonStringify } from 'helpers/safeJsonStringify';
import { PostFormsSignRequestType, PostFormsSignResponseType } from '../types';

function buildFormData(formData: any, data: any, parentKey?: string) {
  if (parentKey === 'contractValues') {
    formData.append(parentKey, safeJsonStringify(data));
  } else if (
    data &&
    typeof data === 'object' &&
    !(data instanceof Date) &&
    !(data instanceof File) &&
    !(data instanceof Blob)
  ) {
    Object.keys(data).forEach(key => {
      buildFormData(
        formData,
        data[key],
        parentKey ? `${parentKey}[${key}]` : key,
      );
    });
  } else if (data instanceof Date) {
    formData.append(parentKey, data.toISOString());
  } else if (typeof data === 'number') {
    formData.append(parentKey, data.toString());
  } else if (typeof data === 'boolean') {
    formData.append(parentKey, data ? '1' : '0');
  } else if (data !== null && data !== undefined && data !== '') {
    formData.append(parentKey, data);
  }
}

function jsonToFormData(data: any) {
  const formData = new FormData();

  buildFormData(formData, data);

  return formData;
}

export const postFormsSign = async (request: PostFormsSignRequestType) => {
  const url = `/api/v2/forms/${request.pathParams.form}/sign`;

  const response = await apiAuthClient.post<PostFormsSignResponseType>(
    url,
    jsonToFormData(request.body),
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...request.headers,
      },
    },
  );

  return response.data;
};
